/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchResultDTOFromJSON, SearchResultDTOToJSON, } from './SearchResultDTO';
/**
 * Check if a given object implements the PaginatedResponseSearchResultDTO interface.
 */
export function instanceOfPaginatedResponseSearchResultDTO(value) {
    return true;
}
export function PaginatedResponseSearchResultDTOFromJSON(json) {
    return PaginatedResponseSearchResultDTOFromJSONTyped(json, false);
}
export function PaginatedResponseSearchResultDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(SearchResultDTOFromJSON)),
    };
}
export function PaginatedResponseSearchResultDTOToJSON(json) {
    return PaginatedResponseSearchResultDTOToJSONTyped(json, false);
}
export function PaginatedResponseSearchResultDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(SearchResultDTOToJSON)),
    };
}
